module.exports = __webpack_public_path__ + "files/34d0bb78cb87a5200b125ee892464967.png";